__turbopack_context__.v({
  "edit-image-overlay-btn": "EditCardImageButton-module-scss-module__7GRvVW__edit-image-overlay-btn",
  "error-image-overlay": "EditCardImageButton-module-scss-module__7GRvVW__error-image-overlay",
  "overlay-edit-image-icon": "EditCardImageButton-module-scss-module__7GRvVW__overlay-edit-image-icon",
});
